
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: null,
    },
  },
};
